



























import { Component, Prop } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import { IPartner, IPartnerListRequest } from "@/types/partner";
import { PartnerListRequest } from "@/models/partner";
import List from "@/components/basic/List.vue";
import { IPagination } from "@/types";
import { IProposal } from "@/types/proposal";

@Component({ components: {} })
export default class extends List {
  @Action("partner/salesGetList")
  public partnerGetList!: (params: IPartnerListRequest) => boolean;

  @Getter("partner/list")
  public partnerList!: IPartner[];

  @Getter("partner/pagination")
  public pagination!: IPagination<IProposal>;

  @Mutation("partner/clear")
  public clear!: () => void;

  @Prop()
  public search!: string;

  public headers = [
    {
      text: "uniqueid",
      value: "uniqueid",
    },
    {
      text: "name",
      align: "start",
      value: "name",
    },
    { text: "created", value: "created_at" },
  ];

  public params = new PartnerListRequest();

  // override
  public async getList() {
    this.loading = true;
    this.params.page = 1;
    await this.partnerGetList(this.params);
    this.loading = false;

    this.paramsToQuery();
  }

  public rowClick(partner: IPartner): void {
    this.$router.push({
      name: "SalesPartnerDetail",
      params: { partner_id: partner.id.toString() },
    });
  }
}
